var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5C27 22.5751 22.0751 27.5 16 27.5V29.5C23.1797 29.5 29 23.6797 29 16.5H27ZM16 27.5C9.92487 27.5 5 22.5751 5 16.5H3C3 23.6797 8.8203 29.5 16 29.5V27.5ZM5 16.5C5 10.4249 9.92487 5.5 16 5.5V3.5C8.8203 3.5 3 9.3203 3 16.5H5ZM16 5.5C22.0751 5.5 27 10.4249 27 16.5H29C29 9.3203 23.1797 3.5 16 3.5V5.5Z",
    fill: "#024E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3731 13.2071C15.7636 12.8166 15.7636 12.1834 15.3731 11.7929C14.9826 11.4024 14.3494 11.4024 13.9589 11.7929L15.3731 13.2071ZM10.666 16.5L9.95891 15.7929C9.56838 16.1834 9.56838 16.8166 9.95891 17.2071L10.666 16.5ZM13.9589 21.2071C14.3494 21.5976 14.9826 21.5976 15.3731 21.2071C15.7636 20.8166 15.7636 20.1834 15.3731 19.7929L13.9589 21.2071ZM21.3327 17.5C21.885 17.5 22.3327 17.0523 22.3327 16.5C22.3327 15.9477 21.885 15.5 21.3327 15.5V17.5ZM13.9589 11.7929L9.95891 15.7929L11.3731 17.2071L15.3731 13.2071L13.9589 11.7929ZM9.95891 17.2071L13.9589 21.2071L15.3731 19.7929L11.3731 15.7929L9.95891 17.2071ZM21.3327 15.5L10.666 15.5L10.666 17.5L21.3327 17.5V15.5Z",
    fill: "#024E82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.cbe0ded48fd4615fca9b99db619714e2.svg";
export { ForwardRef as ReactComponent };